import { render, staticRenderFns } from "./educationManage.vue?vue&type=template&id=3468f4f2&"
import script from "./educationManage.vue?vue&type=script&lang=js&"
export * from "./educationManage.vue?vue&type=script&lang=js&"
import style0 from "./educationManage.vue?vue&type=style&index=0&id=3468f4f2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports